import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.min.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthState from './context/auth/authState';
import DataState from './context/data/dataState';
import { BrowserRouter as Router } from 'react-router-dom';
import { CoreProvider } from './core';

ReactDOM.render(
  <Router>
    <CoreProvider>
      <Suspense fallback={null}>
        <AuthState>
          <DataState>
            <App />
          </DataState>
        </AuthState>
      </Suspense>
    </CoreProvider>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
